export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 20px 10px 28px',
    justifyContent: 'center'
  },
  numbersContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '20px',
    padding: '10px',
    border: '1px solid #EBEDF2',
    height: '180px',
    width: '730px',
    overflowY: 'auto'
  },
  radioButtons: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '15px'
  },
  searchField: { borderRadius: '4px' },
  searchRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  reloadButton: {
    marginTop: '20px',
    marginLeft: '10px'
  },
  closeIcon: {
    cursor: 'pointer'
  },
  noNumbers: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 40px',
    whiteSpace: 'normal'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: '1px solid #EBEDF2',
    padding: '10px',
    '& button': {
      margin: '10px'
    }
  }
};

export const customStyles = {
  textfieldRoot: {
    marginTop: '20px',
    backgroundColor: '#fff',
    paddingRight: '10px',
    width: '350px'
  }
};
